module.exports = __webpack_public_path__ + "static/img/risk_sp1.61c3703.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/risk_sp1.png
// module id = 929
// module chunks = 1